// CODE_COMMENTS_31

export const FIELD_NAME_MONTH = 'month'
export const FIELD_NAME_SELECTED_CUSTOMERS = 'selectedCustomers'
